"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GetObjectTorrentInput_1 = require("./GetObjectTorrentInput");
var GetObjectTorrentOutput_1 = require("./GetObjectTorrentOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.GetObjectTorrent = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "GetObjectTorrent",
    http: {
        method: "GET",
        requestUri: "/{Bucket}/{Key+}?torrent"
    },
    input: {
        shape: GetObjectTorrentInput_1.GetObjectTorrentInput
    },
    output: {
        shape: GetObjectTorrentOutput_1.GetObjectTorrentOutput
    },
    errors: []
};
//# sourceMappingURL=GetObjectTorrent.js.map